import { useEffect } from 'react'
import '../Contacto/modal.css'
import { useLangContext } from '../../Context/LangContext'
import homeTexts from '.././utils/Texts/homeTexts.json'

const ModalRent = ({ toggleModal }) => {
  const { selectedLanguage } = useLangContext()
  const text = homeTexts[selectedLanguage]

  useEffect(() => {
    const alreadyInitialized = document.getElementById('rental_widget_script')
    if (alreadyInitialized) return

    const script = document.createElement('script')
    script.id = 'rental_widget_script'
    script.type = 'module'
    script.innerHTML = `
      import { RentalGuaranteeWidget } from "https://widgets.winse.online/winse_integration_worker.js";
      if (!window.__rentalWidgetLoaded) {
        const widgetInstance = new RentalGuaranteeWidget('widget_container', 'efcb815e-bdf9-4c3b-8283-4e9d8b2cc9b8');
        widgetInstance.init();
        window.__rentalWidgetLoaded = true;
      }
    `
    document.body.appendChild(script)

    return () => {
      const existingScript = document.getElementById('rental_widget_script')
      if (existingScript) {
        existingScript.remove()
        delete window.__rentalWidgetLoaded
      }
      const container = document.getElementById('widget_container')
      if (container) {
        container.innerHTML = ''
      }
    }
  }, [])

  return (
    <div className="modal-overlay">
      <div className="modal-content-rent">
        <div className="modal-header">
          <h2>
            {text.productButton}
          </h2>
        </div>

        <div id="widget_container" />

        <div className="modal-buttons-rent">
          <button className="modal-button-close" onClick={toggleModal}>
            {text.closeButton}
          </button>
        </div>
      </div>
    </div>
  )
}

export default ModalRent
